import { useCallback } from "react";

export const handleOverlayClick = (onClose?: () => void) => {
  return useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      if (onClose) {
        onClose();
      }
    },
    [onClose]
  );
};
